import { JsonProperty } from "../../../../models/utilities/json-property";
import { MessageStatus } from "../enums/message-status";
import { MessageType } from "../enums/message-type";
import { TemplateType } from "../enums/template-type";

/**
 * Viewmodel for a message details
 */
export class MessageRead {

    public type : MessageType = MessageType.Email;
    public id : number|undefined = undefined;
    public template : TemplateType = TemplateType.InvoiceResend;
    public templateModel : string = '';
    public dealerId : string = '';
    public shipmentId : number|undefined = undefined;
    public destination: string = '';    
    public status : MessageStatus = MessageStatus.Queued;
    public documentPath : string = '';
    public pageCount : number = 0;
    public retryCount : number = 0;
    public mailJobId : number|undefined = undefined;
    public nextTransmissionTime : Date|undefined = undefined;
    @JsonProperty({ toType: 'datetime' })
    public sentTime : Date|undefined = undefined;    
    public errorMessage : string = '';
    public errorStackTrace : string = '';
    @JsonProperty({ toType: 'datetime' })
    public createdOn : Date;

    constructor() {
        this.createdOn = new Date();
    }

}
